import type { PropsWithChildren, ReactNode } from "react";
import type ApplicationRoles from "constants/ApplicationRoles";
import { useUser } from "providers/Authentication/SecuUserProvider";

type Props = PropsWithChildren<{
  roles: Array<ApplicationRoles> | ApplicationRoles;
}>;

function Authorization({ roles, children }: Readonly<Props>): ReactNode {
  const { isRoles } = useUser();

  return <>{isRoles(roles) && children}</>;
}

export default Authorization;
